// import moment from "moment";
import moment, { Moment } from "moment-timezone"
import { NotificationHub } from "@nef/core"

import { DISPLAY_DATE_FORMAT, DISPLAY_DATE_TIME_FORMAT, SERVER_DATE_TIME_FORMAT, SERVER_TZ } from "../constants/common"
import { fetchMarketCloseDays, fetchMarketCloseDaysCustom } from "../redux/utilities/actions"
import { AppDispatch } from "../app/store"
import { MarketHoliday } from "../types/MarketHoliday"

enum timeStandards {
  EST = "est",
  IST = "ist"
}

const timeZoneUTCDifference: { [key in timeStandards]: string } = {
  [timeStandards.EST]: "-4",
  [timeStandards.IST]: "+5.5"
}

const getConvertedHours = (date: Date, hours: string): Date => {
  date.setHours(date.getHours() + +hours)
  return date
}

export const convertUTC = (date: Date, timeStandard: timeStandards = timeStandards.EST): Date => {
  return getConvertedHours(date, timeZoneUTCDifference[timeStandard])
}

const formatDateTime = (inputDate: Date, format = "MM/DD/YYYY"): string => {
  const UTCString = inputDate.toUTCString()
  const date = new Date(UTCString.replace("GMT", ""))

  if (format === "MM/DD/YYYY HH:MM:SS") {
    // "MM/DD/YYYY HH:MM:SS"
    const padL = (nr: number, len = 2, chr = `0`) => `${nr}`.padStart(2, chr)
    return `${padL(date.getMonth() + 1)}/${padL(date.getDate())}/${date.getFullYear()} ${padL(date.getHours())}:${padL(date.getMinutes())}:${padL(
      date.getSeconds()
    )}`
  }

  const month = `0${date.getMonth() + 1}`
  const dt = `0${date.getDate()}`
  // MM/DD/YYYY
  return `${date.getMonth() > 8 ? date.getMonth() + 1 : month}/${date.getDate() > 9 ? date.getDate() : dt}/${date.getFullYear()}`
}

export const getFormatedDateFromUTC = (date: string, format = "MM/DD/YYYY"): string => {
  if (!date) return "-"
  return formatDateTime(convertUTC(new Date(date)), format)
}

export const dateFormatForDisplay = (date: any) => (date && moment(date).isValid() ? moment(date).format(DISPLAY_DATE_FORMAT) : "-")
export const dateFormatForDisplayServerTZ = (date: any) =>
  date && moment(date).isValid() ? moment(date).tz(SERVER_TZ).format(DISPLAY_DATE_FORMAT) : "-"
export const dateTimeFormatForDisplay = (date: any) =>
  date && moment(date).isValid() ? moment(date).tz(SERVER_TZ).format(DISPLAY_DATE_TIME_FORMAT) : "-"

export const getServerTimeFormatForDisplay = (date: string | Date | Moment) =>
  date && moment(date).isValid() ? moment(date).tz(SERVER_TZ).format(SERVER_DATE_TIME_FORMAT) : "-"

export const getAdjustedDate = (date: Date) => {
  const dayOfWeek = date.getDay()
  if (dayOfWeek === 6) {
    // Saturday
    date.setDate(date.getDate() + 2) // Skip to Monday
  } else if (dayOfWeek === 0) {
    // Sunday
    date.setDate(date.getDate() + 1) // Skip to Monday
  }
  return date
}

export const isWeekend = (date: Date | undefined) => date?.getDay() === 6 || date?.getDay() === 0

export const isWeekendOrMarketClose = (date: Date | undefined, combinedHolidays: MarketHoliday[]): { disabled: boolean; reason?: string } => {
  if (!date) return { disabled: false }

  const isDateWeekend = date.getDay() === 0 || date.getDay() === 6
  if (isDateWeekend) {
    return { disabled: true, reason: "Weekend" }
  }

  const marketCloseDatesList: any[] = combinedHolidays.map((item: any) => {
    return { date: moment(item.calendarDate), reason: item?.reason }
  })

  const marketClose = marketCloseDatesList.find((holiday) => moment(holiday.date).isSame(date, "day"))

  if (marketClose) {
    return { disabled: true, reason: marketClose.reason }
  }

  return { disabled: false }
}

export const getMarketHolidays = async (dispatch: AppDispatch, isLoading: Function | null = null) => {
  if (!dispatch) return
  const payload = {
    params: {
      year: new Date().getFullYear()
    }
  }
  try {
    isLoading?.(true)
    const promises = []
    promises.push(fetchMarketCloseDays)
    promises.push(fetchMarketCloseDaysCustom)
    await Promise.allSettled(promises.map((promise: any) => dispatch(promise(payload)).unwrap()))
  } catch (error: any) {
    NotificationHub.send("danger", `${error.message}`)
  } finally {
    isLoading?.(false)
  }
}

export default formatDateTime
